import type { Tag, TagAdd, TagUpdate } from "../models/tag";
import { createCrudStoreBundle } from "./crud.store";
import type { ApiClient } from "./shared";

/** API tag row; extras allowed beyond parsed Tag fields. */
export type TagEntity = Tag & {
	readonly [key: string]: unknown;
};

export const createTagsStore = (apiClient: ApiClient) =>
	createCrudStoreBundle<TagEntity, TagAdd, TagUpdate>({
		apiClient,
		entityPath: "tags",
	});
